/** 
 * @type {import("./defs").StoreNews} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StoreNews} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StoreNews.js